<template>
	<div :class="['container__numericinput', { disabled }]">
		<i
			class="fas fa-minus"
			@click="decrementar"
		/>
		<input
			type="number"
			:value="value"
			:style="{ width: inputWidth + 'px' }"
			:disabled="disabled"
			@input="updateValue"
			@keyup="adjustInputWidth"
		/>
		<i
			class="fas fa-plus"
			@click="incrementar"
		/>
	</div>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		value: Number,
	},
	data() {
		return {
			inputWidth: 30,
		}
	},
	methods: {
		incrementar() {
			if (!this.disabled) {
				this.$emit('input', this.value + 1)
				this.adjustInputWidth()
			}
		},
		decrementar() {
			if (!this.disabled) {
				this.$emit('input', this.value - 1)
				this.adjustInputWidth()
			}
		},
		updateValue(event) {
			const newValue = Number(event.target.value)
			if (!isNaN(newValue)) {
				this.$emit('input', newValue)
			}
		},
		adjustInputWidth() {
			this.inputWidth = Math.max(30, this.value.toString().length * 10)
		},
	},
}
</script>

<style scoped>
.container__numericinput {
	border-radius: 4.5px;
	border: 1px solid rgb(var(--color-primary));
	display: flex;
	align-items: center;
	height: 2rem;
	padding: 0 1rem;
	justify-content: space-between;
}

.container__numericinput.disabled {
	background-color: lightgray;
	cursor: not-allowed;
}

.container__numericinput i {
	font-size: 0.75rem;
	font-weight: 900;
	cursor: pointer;
}

.container__numericinput.disabled i {
	cursor: not-allowed;
}

.container__numericinput > input {
	text-align: center;
	margin: 0 0.5rem;
	width: 2rem;
}

.container__numericinput > input:disabled {
	cursor: not-allowed;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
</style>
